import { get, post } from "../request-manager";

export interface ListOpenAccessKeysParams {
  page: number;
  pageSize: number;
  status?: 'ENABLED' | 'EXPIRED';
}

export function getAccessKeyManagementList(params: ListOpenAccessKeysParams): Promise<any> {
  return get(`/v1alpha1/openAccessKeys`, { params });
}

export function CreateAccessKey(params: AccessKeyManagementType.CreateAccessKeyManagementParam): Promise<AccessKeyManagementType.CreateAccessKeyManagementRes> {
  return post(`/v1alpha1/openAccessKeys`, params);
}

export function deleteAccessKey(params: any) {
  return post(`/v1alpha1/openAccessKeys/delete`, params);
}

/** 续期：已启用和已过期的 Key 均可续期 */
export function renewAccessKey(params: AccessKeyManagementType.RenewAccessKeyParam): Promise<{ code: number }> {
  return post(`/v1alpha1/openAccessKeys/renew`, params);
}

/** V1 升级至 V3 */
export function upgradeAccessKeyToV3(params: AccessKeyManagementType.UpgradeAccessKeyParam): Promise<{ code: number }> {
  return post(`/v1alpha1/openAccessKeys/upgrade`, params);
}

/** 更新 Secret：仅已启用的 V3 Key（全新 V3）可用 */
export function updateAccessKeySecret(params: AccessKeyManagementType.UpdateSecretParam): Promise<AccessKeyManagementType.UpdateSecretRes> {
  return post(`/v1alpha1/openAccessKeys/updateSecret`, params);
}

/** 下载 Secret：仅未过期的全新 V3（clientId 有值）可下载 */
export function downloadAccessKeySecret(params: AccessKeyManagementType.DownloadSecretParam): Promise<AccessKeyManagementType.DownloadSecretRes> {
  return post(`/v1alpha1/openAccessKeys/download`, params);
}
